// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--75d75";
export var headingContainer = "index-module--heading-container--f9440";
export var highlight = "index-module--highlight--2fad6";
export var highlightLine = "index-module--highlight-line--cfa4a";
export var image1 = "index-module--image-1--3ab7a";
export var image2 = "index-module--image-2--eaf0d";
export var imageContainer = "index-module--image-container--1b5dc";